import { createApi } from '@reduxjs/toolkit/query/react';
import pkdAPIBaseQuery from './base';

const pkdApi = createApi({
  reducerPath : 'pkdApi',
  baseQuery   : pkdAPIBaseQuery(),
  tagTypes    : [
    'User',
    'ParticipantTasks',
    '1UpStatus',
    '1UpProviderList',
    'DailySurveys',
    'DailySurveysCompleted',
    'Country'
  ],
  endpoints : () => ({}),
});

export default pkdApi;
